export const siigoPath = {
  SIIGO_INVOICES: "",
  SIIGO_INVOICE_DETAIL: "/:id",
  SIIGO_VIEW_INVOICE: (id) => `${id}`,
  SIIGO_REFUND_VOUCHER_REPORT: "voucher/refund",
  SIIGO_VOUCHER_TOPUP_REPORT: "voucher/topup",
  SIIGO_ADJUSTMENT_VOUCHER_REPORT: "voucher/adjustment",
  SIIGO_VOUCHER_DETAILS: "/voucher/details/:vouchertype/:id",
  SIIGO_TOPUP_VOUCHER_DETAILS_ID: (id) => `/voucher/details/topup/${id}`,
  SIIGO_REFUND_VOUCHER_DETAILS_ID: (id) => `/voucher/details/refund/${id}`,
  SIIGO_ADJUSTMENT_VOUCHER_DETAILS_ID: (id) => `/voucher/details/adjustment/${id}`
};
